import { render, staticRenderFns } from "./HeaderCostQuotation.vue?vue&type=template&id=823f9d3e"
import script from "./HeaderCostQuotation.vue?vue&type=script&lang=js"
export * from "./HeaderCostQuotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports